import { render } from "./StatsVideoSection.vue?vue&type=template&id=7b9e6e10&scoped=true"
import script from "./StatsVideoSection.vue?vue&type=script&lang=js"
export * from "./StatsVideoSection.vue?vue&type=script&lang=js"

import "./StatsVideoSection.vue?vue&type=style&index=0&id=7b9e6e10&scoped=true&lang=css"

import exportComponent from "../../../.yarn/__virtual__/vue-loader-virtual-6763a87ef6/0/cache/vue-loader-npm-17.4.2-00674d01e5-ffbe3e848e.zip/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b9e6e10"]])

export default __exports__